import { XDropdownSelection } from '@adornis/popover/x-dropdown-selection.js';
import { customElement, state } from 'lit/decorators.js';
import { takeUntil } from 'rxjs';
import './cr-dropdown-selection-content.js';

/**
 * @customElement cr-dropdown-multiselection
 */
@customElement('cr-dropdown-selection')
export class ChromiumDropdownSelection<T> extends XDropdownSelection<T> {
  override emptyState = 'Nichts gefunden';

  private connectedOpenObservable = false;
  @state() private _open = false;

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          borderRadius: `${this.sizes.borderRadiusSecondary} ${this.sizes.borderRadiusSecondary} 0 0`,
          boxShadow: this._open ? `0px 10px 18px 6px ${this.colors.neutral.shade(600)}` : `0`,
        },
      },
    ];
  }

  protected override async _onFocus(event: Event): Promise<boolean> {
    if (!(await super._onFocus(event))) return false;

    if (this.connectedOpenObservable) return true;
    this._adropdown?.isOpen$.pipe(takeUntil(this.disconnected)).subscribe(drop => {
      this._open = drop;
    });
    this.connectedOpenObservable = true;

    return true;
  }
}
